import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { activateTriggerCreator } from 'creators/triggers';
import { getParam, removeParam } from 'utilities/url';

import { shouldShowTrigger } from '../../../shared/utilities/triggers';

export function useShouldShowTrigger(triggerName) {
  const triggerValue = useSelector(
    state =>
      state.triggers.triggers &&
      shouldShowTrigger(state.triggers.triggers, triggerName)
  );

  return triggerValue;
}

export const useUrlTriggerReset = ({ paramName, trigger }) => {
  const dispatch = useDispatch();

  useEffect(() => {
    const override = getParam(paramName);

    if (override) {
      console.log(`Sending trigger reset for ${trigger}`);

      dispatch(activateTriggerCreator(trigger));

      removeParam(window)(paramName);
    }
  }, [dispatch, paramName, trigger]);
};
